var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M7.57145 6.90533L1.02193 7.85748L5.70907 12.5099L4.53268 19.035L10.4701 15.8899L16.394 19.0604L15.2219 12.5303L20.0238 7.89819L13.4547 6.91794L10.502 1.02028L7.57145 6.90533Z","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }